import { AbstractControl } from '@angular/forms';

export function passwordStrengthValidator(control: AbstractControl): PasswordStrengthError {
  const variety = {
    hasLowerCase: hasLowerCase(control.value),
    hasUpperCase: hasUpperCase(control.value),
    hasNumber: hasNumber(control.value),
    hasSpecialCharacters: hasSpecialCharacters(control.value),
  };
  const varietyCount = Object.values(variety).filter((v) => v).length;

  if (varietyCount === 1) {
    return {
      passwordStrength:
        'Weak! You need a mix of symbols, numbers, upper case letters, and lower cases letters.',
    };
  }

  const minRequiredVariety = 3;
  if (varietyCount < minRequiredVariety) {
    let suggestion = '';
    if (!variety.hasLowerCase && !variety.hasUpperCase) {
      suggestion = 'Try adding an upper case letter or lower case letter.';
    } else {
      const varietyNames = {
        hasLowerCase: 'a lower case letter',
        hasUpperCase: 'an upper case letter',
        hasNumber: 'a number',
        hasSpecialCharacters: 'a symbol',
      };
      const missingCases = Object.keys(variety)
        .filter((k) => !variety[k])
        .map((k) => varietyNames[k]);

      suggestion = `Try adding ${missingCases.join(' or ')}.`;
    }

    return {
      passwordStrength: `Still too weak!
        You need a mix of 3 of these 4 types:
        symbols, numbers, upper case letters, and lower case letters.
         ${suggestion}`,
    };
  }

  return null;
}

export interface PasswordStrengthError {
  passwordStrength: string;
}

export function hasPasswordStrengthError(errors: any): errors is PasswordStrengthError {
  return (errors as PasswordStrengthError).passwordStrength !== undefined;
}

function hasLowerCase(str: string) {
  return str.toUpperCase() !== str;
}

function hasUpperCase(str: string) {
  return str.toLowerCase() !== str;
}

function hasNumber(str: string) {
  return /\d/g.test(str);
}

/* eslint-disable no-useless-escape */
function hasSpecialCharacters(str: string) {
  const regex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
  return regex.test(str);
}
